import { TBillingRecipientRow } from "@/features/company/types/company-form";

export type TBillingRecipientColumn = {
  key: keyof TBillingRecipientRow;
  label: string;
  width: number;
  required?: boolean;
  /** Filled from 郵便番号, so the cell renders a read-only input. */
  readonly?: boolean;
};

/** Columns of the 請求先情報 table — one row per 拠点 receiving invoices. Wider than the card, so the table scrolls horizontally. */
export const BILLING_RECIPIENT_COLUMNS: TBillingRecipientColumn[] = [
  { key: "locationType", label: "事業所／営業所選択", width: 180, required: true },
  { key: "locationName", label: "事業所／営業所名", width: 180, required: true },
  { key: "addressee", label: "宛名", width: 160 },
  { key: "zipCode", label: "郵便番号", width: 140 },
  { key: "prefecture", label: "都道府県", width: 140, readonly: true },
  { key: "city", label: "市区町村", width: 140, readonly: true },
  { key: "addressDetail", label: "町名丁目番地号等", width: 200 },
  { key: "contactPerson", label: "連絡担当者", width: 160 },
  { key: "email", label: "メールアドレス", width: 200 },
];

/** Width reserved for the trailing 削除 icon column. */
export const BILLING_RECIPIENT_ACTION_WIDTH = 48;

export const BILLING_RECIPIENT_GRID_TEMPLATE = [...BILLING_RECIPIENT_COLUMNS.map(({ width }) => `${width}px`), `${BILLING_RECIPIENT_ACTION_WIDTH}px`].join(" ");
